import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import TemplateComponent from './templates/template-simple.component';
import Template2xA5Component from './templates/template-simple-2xa5.component';
import ThermalPrinterComponent from './templates/therm-printer-template.component';
import GlamourTemplateComponent from './templates/template-glamour.component';
import ModernTemplateComponent from './templates/template-modern.component';
import FluxTemplateComponent from './templates/template-flux.component';

import moment from 'moment-timezone'
import { useTranslation } from 'react-i18next';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ApiClient from "../services/api-client"
import { IFrame } from './iframe-component';
import useStore from "../hooks/useStore";
import { API_BASE_URL } from '../util/constants';

const IframePrintTemplate = forwardRef((props, ref) => {

    const { i18n, t } = useTranslation();
    const templateRef = useRef();
    const [printSale, setPrintSale] = useState("");
    moment.tz.setDefault('Europe/Athens');
    let agent = navigator.userAgent;
    
    const _injectThermalStyle = () => {
        if (props.template && props.template.template === "thermal_printer_template") {
            const iframe = document.getElementById("template");
            const iframeDoc = iframe.contentWindow.document;

            // Measure the actual invoice element, not the body, to avoid
            // body margin/overflow inflating the height.
            void iframeDoc.body.offsetHeight; // force reflow
            const pageEl = iframeDoc.getElementById("template_page");
            const heightPx = pageEl ? pageEl.offsetHeight + 20 : iframeDoc.body.scrollHeight + 20;
            const heightMm = Math.ceil(heightPx * 0.2646);

            const existing = iframeDoc.getElementById("thermal-page-style");
            if (existing) existing.remove();

            const style = iframeDoc.createElement("style");
            style.id = "thermal-page-style";
            style.textContent = `@page { size: 80mm ${heightMm}mm; margin: 0; }`;
            iframeDoc.head.appendChild(style);
        }
    }

    const _print = () => {
        _injectThermalStyle();
        if (agent.includes("ANDROID_KEY")) {
            console.log("We are on Android")
            document.getElementById("template").contentWindow.print();
            var cw = document.getElementById("template").contentWindow;
            setTimeout(function () {
                window.Android.runPrintJob(cw.document.documentElement.innerHTML);
            }, 2000)
        }
        else if (agent.includes("APPLE_KEY")) {
            console.log("We are on IOS")
            document.getElementById("template").contentWindow.print();
            var cw = document.getElementById("template").contentWindow;
            setTimeout(function () {
                window.Apple.runPrintJob(cw.document.documentElement.innerHTML);
            }, 2000)
        }
        else {
            document.getElementById("template").contentWindow.print();
        }
    }

    const sendInvoiceEmailWithAttachment = (file, contacts, callback) => {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("contacts", JSON.stringify(contacts));

        ApiClient.sendInvoiceEmailWithAttachment(formData).then(
            response => {
                callback(response);
            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }
    useEffect(() => {
        return
    }, [printSale]);

    const _computeMoreTaxRows = (saleInstanceMoreTaxes, tFn, lang) => {
        if (!saleInstanceMoreTaxes || !saleInstanceMoreTaxes.length) return [];
        const rows = [];
        const seenTypes = [];
        const sorted = [...saleInstanceMoreTaxes].sort((a, b) =>
            a.myDataMoreTax.type.localeCompare(b.myDataMoreTax.type));
        sorted.forEach(e => {
            let type = e.myDataMoreTax.type;
            let deduction = e.deduction;
            if (type === 'DEDUCTION' && e.myDataMoreTax.label) {
                deduction = { ...e.myDataMoreTax, name: e.myDataMoreTax.label };
            }
            const typeLabel = !seenTypes.includes(e.myDataMoreTax.type)
                ? tFn(deduction ? 'DEDUCTION' : type, { lng: lang })
                : '';
            seenTypes.push(e.myDataMoreTax.type);
            const taxKey = e.myDataMoreTax ? 'TAX_' + e.myDataMoreTax.uid : null;
            rows.push({
                typeLabel,
                taxLabel: deduction ? deduction.name : tFn(taxKey, { lng: lang }),
                amount: e.amount,
            });
        });
        return rows;
    };

    useImperativeHandle(ref, () => ({
        getPrintDesign() {



            var printentries = [];
            var counter = 1;
            var countitems = 0;
            var printentry = {
                id: counter++,
                CODE: "123",
                NAME_LIST: "Test Product",
                QUANTITY_LIST: 1,
                MU_LIST: "L",
                UP_LIST: "1.00",
                DISCOUNT: "0.00",
                WHTAXES: "0.00",
                VAT_LIST: 24,
                PRICE_NOVAT_LIST: "1.00",
                PRICE_LIST: "1.24",
            }
            printentries.push(printentry);

            var _comp = useStore.getState().selectedCompany

            var printSale = {
                LOGO: "",
                ISSUER_DOY: _comp.taxpayerId,
                ISSUER_GEMH: _comp.gemh,
                ISSUER_NAME: _comp.name,
                INVOICEMARK: 400001885100498,
                ISSUER_SUBJECTFIELD: "subjectField",
                ISSUER_EMAIL: "email",
                ISSUER_PHONE: "phone",
                ISSUER_ADDRESS: "address",
                CANCELATIONMARK: null,
                INVOICEUID: "50a88a68-50ca-45a6-b82a-37621ebdb77b",
                ISSUER_VAT: _comp.taxpayerId,
                CP_NAME: t("TEST CUSTOMER"),
                CP_CODE: "TEST",
                INVOICE_TYPE: "TEST",
                INVOICE_NUMBER: "Α 1",
                CP_VAT: "000000000",
                INVOICE_DATE: "01/02/2021",
                INVOICE_TIME: moment("01/02/2021").format('LTS'),
                INVOICE_ENTRIES: printentries,
                TOTALTAXES: "0.00",
                TOTALVAT: "0.24",
                TOTALNODISCOUNT: "1.00",
                TOTALWITHOUTVAT: "1.00",
                TOTALWITHVAT: "1.24",
                TOTALPAYMENT: "1.24",
                TOTALDISCOUNT: "0.00",
                CP_ADDRESS: "TEST ADDRESS",
                CP_CITY: "TEST CITY",
                TOTALCOUNTITEMS: 1,
                CP_PAYTYPE: "TEST",
                CP_TAXOFFICE: "TEST",
                CP_SUBJECT_FIELD: "TEST SUBJECT",
                NOTES: "TEST",
                SEND_PLACE: t("ourPlace"),
                TOTALOTHERTAXES: "0.00",
                TOTALWHTAXES: "0.00",
                TOTALFEESTAXES: "0.00",
                TOTALSTUMPOFDUTYTAXES: "0.00",
                VAT_EXCEPTION_CATEGORIES: [t("VatExceptionCategory")],
                IBAN: "GR1234567891234566798",
                MOREINFO: "GR1234567891234566798",
                TEMPLATE_LANG: i18n.language,
                COUNTRY: t("GR")
            }

            return printSale;


        },
        setPrintSale(psale) {
            setPrintSale(psale)
        },
        print(psale) {
            if (psale && psale != "") {
                setPrintSale(psale)
                setTimeout(function () {
                    _print();
                }, 1000);
            }
        },
        printFrame() {
            setTimeout(function () {
                _print();
            }, 1000);
        },
        saveAsPDF(psale) {
            if (psale && psale != "") {
                setPrintSale(psale)
                setTimeout(function () {

                    var t = document.getElementById('template');
                    var docbody = document.getElementById('template').contentWindow.document.body;
                    var dochead = document.getElementById('template').contentWindow.document.head;
                    dochead.innerHTML = '<link  type="text/css" rel="stylesheet" href="template-simple.css"/>' + dochead.innerHTML;
                    html2canvas(docbody).then(canvas => {
                        const imgData = canvas.toDataURL('image/jpeg');
                        const pdf = new jsPDF('p', 'mm', [297, 210]);
                        pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297);
                        var blob = pdf.output('blob');
                        var file = new File([blob], "name");
                        pdf.save("download.pdf");

                    });
                }, 1000);
            }
        },
        _sendEmailWithAttachement(contacts, callback) {
            if (contacts.length > 0) {
                var docbody = document.getElementById('template').contentWindow.document.body;
                var dochead = document.getElementById('template').contentWindow.document.head;
                dochead.innerHTML = '<link  type="text/css" rel="stylesheet" href="template-simple.css"/>' + dochead.innerHTML;

                html2canvas(docbody).then(canvas => {
                    const imgData = canvas.toDataURL('image/jpeg');
                    const pdf = new jsPDF('p', 'mm', [297, 210]);
                    pdf.addImage(imgData, 'JPEG', 0, 0, 210, 297);
                    var blob = pdf.output('blob');
                    var file = new File([blob], "name");
                    sendInvoiceEmailWithAttachment(file, contacts, callback)
                    // pdf.save("download.pdf");

                });
            }
        },
        _sendEmail(contacts, callback) {
            ApiClient.sendInvoiceEmail(contacts).then(
                response => {
                    callback(response);
                },
                error => {
                    console.error(
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString())
                }
            );
        },

        saveAsPDFServerSide(psale) {
            if (!psale) return;
            const template = props.template || {};
            const moreTaxRows = _computeMoreTaxRows(psale.saleInstanceMoreTaxes, t, psale.TEMPLATE_LANG);
            const payload = {
                ...psale,
                MAIN_COLOR: template.mainColor || '#013289',
                SECONDARY_COLOR: template.secondaryColor || 'white',
                APP_FONT: template.appFont || 'Helvetica, Arial, sans-serif',
                MORE_TAXES_ROWS: moreTaxRows,
            };
            fetch(API_BASE_URL + '/sale/pdf', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            }).then(response => {
                if (!response.ok) throw new Error('PDF generation failed');
                return response.blob();
            }).then(blob => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const number = psale.INVOICE_NUMBER || 'invoice';
                a.download = 'invoice_' + number.replace(/[^a-zA-Z0-9_-]/g, '_') + '.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }).catch(err => console.error('PDF error:', err));
        },

    }));

    const getStyle = () => {
        return props.style ? props.style : { height: 0, width: 0 }
    }


    const getMainStyle = () => {
        var str =
            `:root {
        --appcolor: `+ props.template.mainColor + `;
        --secondaryColor:`+ props.template.secondaryColor + `;
        --appfont:`+ props.template.appFont + `;
        }`;
        return str;
    }

    const getTemplateComponent = () => {

        if (props.template) {

            if (props.template.template == "2xa5_simple_template") {

                return <Template2xA5Component extracss={props.extracss} mainStyle={getMainStyle()} t={t} sale={printSale} />
            }
            else if (props.template.template == "thermal_printer_template") {

                return <ThermalPrinterComponent extracss={props.extracss} mainStyle={getMainStyle()} t={t} sale={printSale} />
            }
            else if (props.template.template == "glamour_template") {

                return <GlamourTemplateComponent extracss={props.extracss} mainStyle={getMainStyle()} t={t} sale={printSale} />
            }
            else if (props.template.template == "modern_template") {

                return <ModernTemplateComponent extracss={props.extracss} mainStyle={getMainStyle()} t={t} sale={printSale} />
            }
            else if (props.template.template == "flux_template") {

                return <FluxTemplateComponent extracss={props.extracss} mainStyle={getMainStyle()} t={t} sale={printSale} />
            }
            else {
                return <TemplateComponent extracss={props.extracss} mainStyle={getMainStyle()} t={t} sale={printSale} />
            }
        }
        else {
            return <TemplateComponent extracss={props.extracss} t={t} sale={printSale} />
        }
    }


    return (

        <IFrame id="template" ref={templateRef} style={getStyle()} >
            {getTemplateComponent()}
        </IFrame>
    );
});

export default IframePrintTemplate


